import { render, staticRenderFns } from "./InputComponets.vue?vue&type=template&id=1773bd1f&scoped=true"
import script from "./InputComponets.vue?vue&type=script&lang=js"
export * from "./InputComponets.vue?vue&type=script&lang=js"
import style0 from "./InputComponets.vue?vue&type=style&index=0&id=1773bd1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1773bd1f",
  null
  
)

export default component.exports